export async function downloadExportFile({
  url,
  filename = 'download',
  adminBase,
  getToken,
  legacyDownload,
  onLoginExpired
}) {
  let target
  try {
    if (typeof url !== 'string' || !url.trim()) throw new Error()
    target = new URL(url, window.location.href)
  } catch (_) {
    throw new Error('文件地址无效')
  }
  // 普通历史链接无需 Admin 配置。
  if (!['http:', 'https:'].includes(target.protocol))
    throw new Error('文件地址无效')
  const isProduction = process.env.VUE_APP_ENV === 'production'
  const isPrivatePath = isProduction
    ? target.pathname.includes('oss-prod-tms')
    : target.pathname.includes('/oss/private-files/')
  if (!isPrivatePath) {
    return legacyDownload(url, filename)
  }
  let admins
  try {
    if (!adminBase) throw new Error()
    admins = adminBase.split(',').map(base => {
      const admin = new URL(base.trim())
      if (!['http:', 'https:'].includes(admin.protocol)) throw new Error()
      return admin
    })
  } catch (_) {
    throw new Error('当前环境未配置有效的 Admin 文件服务地址')
  }
  // 只有当前环境 Admin 服务的私有文件链接才携带 Token 下载。
  if (!admins.some(admin => target.origin === admin.origin)) {
    return legacyDownload(url, filename)
  }
  // 生产环境仅按 oss-prod-tms 标识判断，测试环境保留完整路径校验。
  const privatePath = /^\/admin\/oss\/private-files\/[A-Za-z0-9_-]+\/content\/[^/]+$/
  const matchesPrivatePath = isProduction
    ? target.pathname.includes('oss-prod-tms')
    : privatePath.test(target.pathname)
  const privateFile =
    matchesPrivatePath &&
    !target.href.includes('?') &&
    !target.href.includes('#') &&
    !target.username &&
    !target.password
  if (!privateFile) throw new Error('文件服务地址不匹配')
  const expired = () => {
    onLoginExpired()
    const error = new Error('登录已失效，请重新登录')
    error.code = 'AUTH_EXPIRED'
    throw error
  }
  const token = getToken()
  if (!token) expired()
  let response
  try {
    response = await fetch(target.href, {
      method: 'GET',
      headers: { Authorization: token, token },
      credentials: 'omit',
      redirect: 'error',
      cache: 'no-store'
    })
  } catch (_) {
    throw new Error('文件下载失败，请检查网络后重试')
  }
  if (response.status === 401) expired()
  if (!response.ok) {
    const messages = {
      403: '无权下载该文件',
      404: '文件不存在',
      503: '登录校验暂不可用，请重试'
    }
    throw new Error(messages[response.status] || '文件下载失败，请重试')
  }
  const disposition = response.headers.get('Content-Disposition') || ''
  const contentType = response.headers.get('Content-Type') || ''
  // 防止网关的 JSON/HTML 错误页面被保存为 Excel；正常附件允许该类型。
  if (
    /application\/json|text\/html/i.test(contentType) &&
    !/attachment/i.test(disposition)
  ) {
    throw new Error('文件响应异常，请重试')
  }
  const match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  let name = filename
  try {
    if (match) name = decodeURIComponent(match[1])
  } catch (_) {
    // 无效的响应文件名使用任务名称。
  }
  // eslint-disable-next-line no-control-regex
  name = String(name).replace(/[\x00-\x1f\x7f/\\]/g, '_') || 'download'
  const blob = await response.blob()
  const objectUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  try {
    link.href = objectUrl
    link.download = name
    document.body.appendChild(link)
    link.click()
  } finally {
    link.remove()
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000)
  }
}
